import { ITransferCollegesDatasource } from './../datasources/transfer_colleges_datasource';
import { College } from './../builders/college_builder';
import { IDefineCommand, IQueryMediator, ICommand, IQuery } from 'core-ts-types';
import { TransferTransactionModel } from '../models/transfer_transaction_model';

angular.module('capability-ng-transfer').factory(
  'selectTransferCollegeCommand',
  (
    defineCommand: IDefineCommand,
    QueryMediator: IQueryMediator,
    ngTransferCollegesDatasource: ITransferCollegesDatasource,
    ngCollegeBuilder: typeof College,
    ngTransferCollegeTransactionModel: TransferTransactionModel,
    $http: ng.IHttpService
  ): ICommand => {
    return defineCommand('selectTransferCollegeCommand', function selectMajor(
      deferred: ng.IDeferred<IQuery[]>,
      college: College
    ): void {
      const isAlreadyProcessed =
        ngTransferCollegeTransactionModel.ids.has(college.id) || ngTransferCollegesDatasource.get(college.id);
      if (!college || isAlreadyProcessed) {
        return deferred.resolve(QueryMediator.runQueries());
      }
      ngTransferCollegeTransactionModel.ids.add(college.id);

      $http({
        method: 'POST',
        url: `student/college/`,
        data: {
          college: college.nk
        }
      })
        .then((response: ng.IHttpPromiseCallbackArg<any>): void => {
          ngTransferCollegesDatasource.put(_.merge(college, { created_ts: response.data.results.created_ts }));
          deferred.resolve(QueryMediator.runQueries(ngTransferCollegesDatasource));
        })
        .catch(deferred.reject)
        .finally(() => ngTransferCollegeTransactionModel.ids.delete(college.id));
    });
  }
);



// WEBPACK FOOTER //
// ./app/lib/transfer/commands/select_transfer_college_command.ts